import { InputTextFormikStyle } from "./style";

export interface InputTextFormikProps {
    type: string;
    placeholder: string;
    name: string;
    required?: boolean;
    marginbottom?: string;
}
export const InputTextFormik: React.FC<InputTextFormikProps> = ({ name, type, placeholder, required, marginbottom }) => {
    return (
        <InputTextFormikStyle name={name} type={type} placeholder={placeholder} required={required} marginbottom={marginbottom} />        
    )
}